import {Component, computed, input, output} from '@angular/core';
import {ZonesListItem} from "../../models";
import {ZoneIconComponent} from "../../icons/zone-icon/zone-icon.component";
import {NgOptimizedImage} from "@angular/common";
import {ChipComponent} from "../../common/chip/chip.component";
import {LoaderComponent} from "../../common/loader/loader.component";

@Component({
    selector: 'zones-list-item',
    standalone: true,
    imports: [
        ZoneIconComponent,
        NgOptimizedImage,
        ChipComponent,
        LoaderComponent
    ],
    templateUrl: './zones-list-item.component.html',
    styleUrl: './zones-list-item.component.scss'
})
export class ZonesListItemComponent {
    zonesListItem = input.required<ZonesListItem>();
    itemClick = output<void>();
    isChanging = computed(() => this.zonesListItem().duringChange);
    isDisabled = computed(() => {
        const status = this.zonesListItem().status;
        return this.isChanging() || status === 'noCommunication' || status === 'zoneUnregistered';
    });

    onClick(): void {
        if (this.isDisabled()) {
            return;
        }
        this.itemClick.emit();
    }
}
